export * from './isAutomatedBrowser';
export * from './isChunkLoadError';
export * from './isProductionEnvironment';
export { logToExternalErrorHandlers, type SentryAttachment } from './logToExternalErrorHandlers';
export * from './throwErrorUnlessProduction';
